import MapBrowserEventHandlerClass, * as MapBrowserEventHandlerModule from './../node_modules/ol/MapBrowserEventHandler.js';

// Create a wrapper class
class MapBrowserEventHandler extends MapBrowserEventHandlerClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in MapBrowserEventHandlerModule) {
    if (key !== "default") {
        MapBrowserEventHandler[key] = MapBrowserEventHandlerModule[key];
    }
}

export default MapBrowserEventHandler;

// Re-export ALL named exports from OL
export * from './../node_modules/ol/MapBrowserEventHandler.js';